import { type Artwork } from '../types/art.types'

// Note: the normalizeParams function in the backend replaces this URL with the url of the original artwork
export function getArtworkThumbnailUrl(artwork: Artwork): string {
  const { cloudinaryName, publicId } = artwork
  // Decode before encoding to prevent possible double-encoding of some characters (if they're already encoded in publicId for some reason)
  const encodedPublicId = encodeURIComponent(
    decodeURIComponent(publicId)
  ).replaceAll("'", '%27')
  return `https://res.cloudinary.com/${cloudinaryName}/image/private/t_artwork_large_thumbnail/${encodedPublicId}`
}

const MAX_ART_PRINT_PIXELS = 7000

// Inside cloudinary, we have a transformation that minifies the image to support a max width or height of 7000 pixels
// This function calculates the new width and height of the artwork image after applying this transformation
export function calculateArtworkDimensions(
  origWidth: number,
  origHeight: number
): { width: number; height: number } {
  if (origWidth <= MAX_ART_PRINT_PIXELS && origHeight <= MAX_ART_PRINT_PIXELS) {
    return { width: origWidth, height: origHeight }
  }

  // Calculate scale factor to fit within the limit while preserving aspect ratio
  const scaleFactor = Math.min(
    MAX_ART_PRINT_PIXELS / origWidth,
    MAX_ART_PRINT_PIXELS / origHeight
  )
  const newWidth = Math.round(origWidth * scaleFactor)
  const newHeight = Math.round(origHeight * scaleFactor)

  return { width: newWidth, height: newHeight }
}
